import React from 'react';

const Divider = (props) => {
    let color = 'primary-200';
    if (props.color) {
        color = `${props.color}-primary`;
    }

    return (
        <div className="w-full flex items-center">
            {props.title ? (
                <>
                    <span className={`flex-1 h-1 bg-${color}`}></span> {/* Left divider line */}
                    <span className="text-lg text-black mx-2"> {/* Title with horizontal margin */}
                        {props.title}
                    </span>
                    <span className={`flex-1 h-1 bg-${color}`}></span> {/* Right divider line */}
                </>
            ) : (
                <span className={`h-1 w-full bg-${color}`}></span> // Full width line when no title
            )}
        </div>
    );
};

export default Divider;